'use client'

import { TypeStyleHeadlineExtraSmall } from '@syconium/little-miss-figgy/dist/components/TypeStyle'

import { gql } from '../../../../../__generated__/graphql/catalog/gql'
import { PageTitleSectionFragmentFragment } from '../../../../../__generated__/graphql/catalog/graphql'
import { PageSection } from '../../PageSection.client'

import { ContentfulPageTitleSectionContent } from './ContentfulPageTitleSection.styles'

export const pageTitleSectionFragment = gql(`
  fragment PageTitleSectionFragment on PageTitleSection {
    __typename
    id
    title
  }
`)

export type ContentfulPageTitleSectionProps = {
  data: PageTitleSectionFragmentFragment
}

export const ContentfulPageTitleSection = ({ data }: ContentfulPageTitleSectionProps) => {
  return (
    <PageSection>
      <ContentfulPageTitleSectionContent>
        <TypeStyleHeadlineExtraSmall isUppercase textTransform='uppercase' asTag='h3'>
          {data.title}
        </TypeStyleHeadlineExtraSmall>
      </ContentfulPageTitleSectionContent>
    </PageSection>
  )
}
